if (!customElements.get('related-products-carousel')) {
  customElements.define(
    'related-products-carousel',
    class RelatedProductsCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-related-track]');
        this.scrollbar = this.querySelector('[data-related-scrollbar]');
        this.thumb = this.querySelector('[data-related-thumb]');
        if (!this.track || !this.thumb) return;

        this.updateThumb = this.updateThumb.bind(this);
        this.track.addEventListener('scroll', this.updateThumb);
        this.resizeObserver = new ResizeObserver(this.updateThumb);
        this.resizeObserver.observe(this.track);
        this.updateThumb();

        if (this.scrollbar) this.bindDrag();
        this.initTrackDrag();
      }

      initTrackDrag() {
        const track = this.track;
        let dragging = false, didDrag = false, startX, scrollStart;
        track.style.cursor = 'grab';
        track.addEventListener('mousedown', (e) => {
          dragging = true; didDrag = false; startX = e.pageX; scrollStart = track.scrollLeft;
          track.style.cursor = 'grabbing'; track.style.scrollSnapType = 'none'; e.preventDefault();
        });
        document.addEventListener('mousemove', (e) => {
          if (!dragging) return;
          if (Math.abs(e.pageX - startX) > 5) didDrag = true;
          track.scrollLeft = scrollStart - (e.pageX - startX);
        });
        document.addEventListener('mouseup', () => {
          if (!dragging) return; dragging = false;
          track.style.cursor = 'grab'; track.style.scrollSnapType = 'x mandatory';
          if (didDrag) setTimeout(() => { didDrag = false; }, 0);
        });
        track.addEventListener('click', (e) => {
          if (didDrag) { e.preventDefault(); e.stopPropagation(); }
        }, true);
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      updateThumb() {
        const { track, thumb } = this;
        const max = track.scrollWidth - track.clientWidth;
        if (max <= 0) {
          thumb.style.width = '100%';
          thumb.style.left = '0';
          return;
        }
        const visibleEnd = track.scrollLeft + track.clientWidth;
        const progress = Math.min(100, (visibleEnd / track.scrollWidth) * 100);
        thumb.style.width = progress + '%';
        thumb.style.left = '0';
      }

      bindDrag() {
        const { track, scrollbar, thumb } = this;
        let dragging = false;
        let startX = 0;
        let startScrollLeft = 0;

        const start = (e) => {
          dragging = true;
          startX = e.touches ? e.touches[0].clientX : e.clientX;
          startScrollLeft = track.scrollLeft;
          document.body.style.userSelect = 'none';
          e.preventDefault();
        };
        const move = (e) => {
          if (!dragging) return;
          const x = e.touches ? e.touches[0].clientX : e.clientX;
          const dx = x - startX;
          const max = track.scrollWidth - track.clientWidth;
          const sbW = scrollbar.clientWidth;
          if (sbW <= 0 || max <= 0) return;
          track.scrollLeft = startScrollLeft + (dx / sbW) * max;
        };
        const stop = () => {
          dragging = false;
          document.body.style.userSelect = '';
        };

        thumb.addEventListener('mousedown', start);
        thumb.addEventListener('touchstart', start, { passive: false });
        document.addEventListener('mousemove', move);
        document.addEventListener('touchmove', move, { passive: false });
        document.addEventListener('mouseup', stop);
        document.addEventListener('touchend', stop);

        scrollbar.addEventListener('click', (e) => {
          if (e.target === thumb || dragging) return;
          const rect = scrollbar.getBoundingClientRect();
          const clickX = e.clientX - rect.left;
          const max = track.scrollWidth - track.clientWidth;
          const ratio = track.clientWidth / track.scrollWidth;
          const thumbWidthPx = ratio * scrollbar.clientWidth;
          const target = ((clickX - thumbWidthPx / 2) / scrollbar.clientWidth) * track.scrollWidth;
          track.scrollTo({ left: Math.max(0, Math.min(max, target)), behavior: 'smooth' });
        });
      }
    }
  );
}
